import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import cmrRatings from "../../../../src/data/articles/cube-prospective-commander-legends/cmr-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  cmrRatings,
  ProspectiveIntro,
  React
};